import axios from 'axios';

let requestSequence = 0;

export const PropertySuggestionsApi = {
  request: async function (address, onSuccess) {
    const currentSequenceNo = ++requestSequence;

    try {
      const response = await axios.get('/api/suggestion/2/address', {params: {address}, _hideErrors: true});

      if (currentSequenceNo < requestSequence) {
        return;
      }

      const mapped = response.data.map(property => ({
        singleLineAddress: property.address,
        propertyId: property.propertyId
      }));
      onSuccess(mapped);
    } catch (e) {
      // ignore
    }
  }
};
